const colors = {
  alertBlue: {
    DEFAULT: "#9ACDFF",
    50: "#FFFFFF",
    100: "#FFFFFF",
    200: "#F4F8FF",
    300: "#ECF5FF",
    400: "#C3E1FF",
    500: "#9ACDFF",
    600: "#62B1FF",
    700: "#2A95FF",
    800: "#007AF1",
    900: "#005DB9",
    950: "#004F9D",
  },
  caminoNewErrorRed: {
    DEFAULT: "#E92E4D",
    50: "#FAD4DA",
    100: "#F9C2CB",
    200: "#F59DAB",
    300: "#F1788C",
    400: "#ED536C",
    500: "#E92E4D",
    600: "#CA1533",
    700: "#971026",
    800: "#640B19",
    900: "#31050D",
    950: "#180306",
    opacity5: "#E92E4D0D",
    opacity10: "#E92E4D1A",
    opacity50: "#E92E4D80",
  },
  brand: {
    DEFAULT: "#4097EB",
    500: "#4097EB",
  },
  linkBlue: {
    DEFAULT: "#4097EB",
    500: "#4097EB",
    opacity5: "rgba(64, 151, 235, 0.05)",
    opacity10: "rgba(64, 151, 235, 0.1)",
  },
  skippedGrey: {
    DEFAULT: "#C3C0C0",
    500: "#C3C0C0",
  },
  resolveGrey: {
    DEFAULT: "#F4F4F9",
    500: "#F4F4F9",
    HOVER: "#E0E0E9",
  },
  sentGreen: {
    DEFAULT: "#27C26F",
    500: "#27C26F",
  },
  tagGreen: {
    text: "#3D6838",
  },
  backgroundBlue: {
    light: "#F1F8FF",
    dark: "#0D1B2A",
  },
  newHireGreen: {
    bg: "#E6F7F6",
    text: "#11B2AA",
    bgHover: "#D0EFED",
    textHover: "#2DC1BA",
  },
  peopleTeamBlue: {
    light: "#ECF6FF", // 100
    dark: "#5BA8F2", // 800
    lightHover: "#D6EBFD", // 200
    darkHover: "#78B8F6", // 700
  },
  valueBlack: {
    DEFAULT: "#535353",
    500: "#535353",
  },
  searchBarGrey: {
    DEFAULT: "#C1BFBF",
    500: "#C1BFBF",
  },
  trixBorderGrey: "#D8D8D8",
  tagRed: {
    text: "#E92E4D",
    bg: "#E92E4D17",
  },
  tableUnderlineBorder: {
    DEFAULT: "#D9D9D9",
    500: "#D9D9D9",
    opacity16: "#D9D9D929",
  },
  tableBorder: {
    DEFAULT: "#E0E0E0",
    500: "#E0E0E0",
  },
  hasValueBorder: {
    DEFAULT: "#BBDDFE",
    500: "#BBDDFE",
  },
  multiSelectBlue: {
    DEFAULT: "rgba(89, 197, 238, 0.1)",
    500: "rgba(89, 197, 238, 0.1)",
  },
  successGreen: {
    DEFAULT: "#77D1A1",
    500: "#77D1A1",
  },
  error: {
    DEFAULT: "#EC7464",
    500: "#EC7464",
    opacity5: "rgba(236, 116, 100, 0.05)",
    opacity10: "rgba(236, 116, 100, 0.1)",
  },
  statusRed: {
    bg: "#FFECEA",
    text: "#EB5D4B",
  },
  issueDotRed: {
    DEFAULT: "#E37970",
  },
  creamBg: {
    DEFAULT: "#FCFAF8",
    500: "#FCFAF8",
    opacity10: "#FCFAF8",
    opacity20: "#FCFAF8",
  },
  issueGrey: {
    700: "#585858",
  },
  dateYellow: {
    DEFAULT: "rgba(234, 184, 64)",
    500: "rgba(234, 184, 64)",
    background: "rgba(234, 184, 64, 0.05)",
  },
  dateBlue: {
    DEFAULT: "rgba(64, 151, 235, 1)",
    500: "rgba(64, 151, 235, 1)",
    background: "rgba(64, 151, 235, 0.05)",
  },
  dateGreen: {
    DEFAULT: "rgba(119, 209, 161, 1)",
    500: "rgba(119, 209, 161, 1)",
    background: "rgba(119, 209, 161, 0.05)",
  },
  border: {
    default: "gray.200",
  },
  badgeRed: {
    DEFAULT: "rgba(229, 62, 62, 0.6)",
  },
  darkModeHoverColor: {
    DEFAULT: "#F2F2F2",
    100: "#F2F2F2",
    200: "#E0E0E0",
  },
  disabledGray: {
    DEFAULT: "#B4B4B4",
    text: "#6C6C6C",
  },
  editableBackgroundGrey: {
    light: "#E5E5E5",
    dark: "#2D2D2D",
  },
  trixUnfocusedGrey: {
    light: "#F5F5F5",
  },
  meetingTemplateBlue: {
    light: "#D9F6FF",
    dark: "#0EB5ED",
  },
  meetingBlue: {
    dark: "#0EB5ED",
  },
  tentativeYellow: {
    DEFAULT: "#FDF6CC",
  },
  groupBlue: {
    50: "#E8EBFF",
    100: "#D9DDFB",
    200: "#4E61D657",
    400: "#4E61D6",
  },
  singlePink: {
    50: "#FAE6FF",
    100: "#F5DAFA",
    200: "#D0A3DB",
    400: "#854994",
  },
  urgentRed: {
    background: "#FFF1F2",
  },
  actionType: {
    icon: "#818CF8",
    bg: "#EEF2FF",
  },
  meetingOneOnOne: {
    icon: "#6366F1",
    bg: "#E0E7FF",
  },
  meetingGroupSession: {
    icon: "#DB66D0",
    bg: "#FFEBFD",
  },
  meetingRecurring: {
    icon: "#0A91B3", // Camino Cyan 700
    bg: "#A5F3FC", // Camino Cyan 200
  },
} as const;

export type Colors = typeof colors;
export default colors;
